var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-top col",style:({ width: _vm.parseWidth, color: _vm.color }),attrs:{"align-x":"center"},on:{"click":function($event){return _vm.backToTop()}}},[_c('b',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("Back to Top")]),_c('div',{staticClass:"arrow-up",style:({borderColor: _vm.color})})])
}
var staticRenderFns = []

export { render, staticRenderFns }